import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, formatDateAndTime } from "../../../../../helpers/appHelpers";

export const CountryColumns: GridColDef[] = [
	{
		field: "name",
		headerName: "Country",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell: (params) => {
			return (
				<div className="w-full flex items-center gap-3">
					<img
						src={params.row.flagUrl}
						alt="flag"
						className="w-8 h-8 rounded-lg object-cover"
					/>
					<p className="text-sm line-clamp-1">{params.row.name}</p>
				</div>
			);
		},
	},
	{
		field: "code",
		headerName: "Country Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "currency",
		headerName: "Currency",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.row.currency ? (params.row.currency?.name + " " + `(${params.row.currency.symbol})`) : "--",
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "applyLoanDeductionOnBasic",
		headerName: "Apply Loan Deduction On Basic",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "maxLoanDeductionPercentage",
		headerName: "Max Loan Deduction Percentage",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? (Number(params.value) * 100).toFixed(2) + "%" : "--",
	},
	
	...createdAtmodifiedAtActions
];

export const CountryInterestRateHistoryColumns: GridColDef[] = [
	{
		field: "timestamp",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value === null ? "--" : (Number(params.value) * 100).toFixed(2) + "%",
	},
	{
		field: "currentValue",
		headerName: "Current Value",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => (Number(params.value) * 100).toFixed(2) + "%",
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
]